import * as React from 'react';

import * as styles from './CardInfoLayout.css';

export const CardInfoLayout = ({ children }: React.PropsWithChildren) => {
  return <div className={styles['container']}>{children}</div>;
};
